import { Column } from 'new/elements/Table/types';
import { Team } from 'new/entities/Team';
import { Company } from './Company';
import styles from './TeamsTable.module.scss';
import { User } from 'new/entities/User';
import { TeamMembers } from 'new/components/TeamsTable/TeamMembers';

function mapUser(user: User) {
  return {
    ...user,
    fullName: user.name,
  };
}

export const columns = [
  {
    name: 'Team name',
    field: 'name',
    tdClassName: styles.team_name,
    width: 20,
  },
  {
    name: 'Company',
    field: 'org',
    renderRow: Company,
    width: 20,
  },
  {
    name: 'Description',
    field: 'description',
    width: 35,
  },
  {
    name: 'Team members',
    field: 'members',
    renderRow: TeamMembers,
  },
] as Column<Team>[];
